import { Article } from '../../../models';
import { ArticleTableRow } from '../../../models/ArticleTableRow';
import { ArticleListItemDto } from '../../../services/dtos/article/articleListItem.dto';

export const mapArticleToArticleListItemDto = (article: Article): ArticleListItemDto => ({
  id: article.id,
  content: {
    isPrivate: article.content.isPrivate,
    title: article.content.title,
    summary: article.content.summary,
  },
  modifiedDate: article.modifiedDate,
  publishDate: article.publishDate,
  tags: article.tags,
  canAccess: article.canAccess,
});

export const mapArticleTableRowToArticleListItemDto = (articles: ArticleTableRow[]): ArticleListItemDto[] =>
  articles.map((article) => ({
    id: article.id,
    content: article.content,
    tags: article.tags,
    canAccess: article.canAccess,
    modifiedDate: article.modifiedDate,
    publishDate: article.publishDate,
  }));
